import { createContext, useState, useRef, useCallback } from 'react'

export const JobsContext = createContext({})

export function JobsProvider({ children }) {
  const [jobs, setJobs] = useState({})
  const eventSourcesRef = useRef({})

  const setJob = useCallback((jobId, data) => {
    setJobs((prev) => ({
      ...prev,
      [jobId]: { ...prev[jobId], ...data },
    }))
  }, [])

  const start = useCallback(
    ({ alias, jobId, onSuccess, onError, label }) => {
      eventSourcesRef.current[alias]?.close()

      setJob(alias, {
        status: 'pending',
        result: null,
        error: null,
        jobId,
        label,
      })

      const eventSource = new EventSource(
        `${process.env.REACT_APP_BACKEND_API}/jobs/${jobId}/subscribe`,
      )

      eventSourcesRef.current[alias] = eventSource

      eventSource.onmessage = (e) => {
        const job = JSON.parse(e.data)
        eventSource.close()
        delete eventSourcesRef.current[alias]

        if (job.status === 'done') {
          setJob(alias, {
            status: 'done',
            result: job.result,
            error: null,
            date: new Date(),
          })
          onSuccess?.(job.result)
        } else {
          setJob(alias, {
            status: 'error',
            result: null,
            error: job.error,
            date: new Date(),
          })
          onError?.(job.error)
        }
      }

      eventSource.onerror = () => {
        eventSource.close()
        delete eventSourcesRef.current[alias]
        setJob(alias, {
          status: 'error',
          result: null,
          error: 'Conexão perdida',
          date: new Date(),
        })
        onError?.('Conexão perdida')
      }
    },
    [setJob],
  )

  function remove(alias) {
    setJobs((prevState) => delete prevState[alias])
  }

  const cancel = useCallback(
    (alias) => {
      eventSourcesRef.current[alias]?.close()
      delete eventSourcesRef.current[alias]

      setJob(alias, { status: 'idle', result: null, error: null })
    },
    [setJob],
  )

  const getJob = useCallback(
    (alias) => {
      return jobs[alias]
    },
    [jobs],
  )

  return (
    <JobsContext.Provider value={{ start, cancel, getJob, jobs, remove }}>
      {children}
    </JobsContext.Provider>
  )
}
